import { Link } from 'react-router-dom'
import { categories, movies } from '@/mocks/movies'

const accents = [
  { bg: 'bg-primary-100', text: 'text-primary-800', iconBg: 'bg-primary-800' },
  { bg: 'bg-accent-100', text: 'text-accent-800', iconBg: 'bg-accent-500' },
  { bg: 'bg-secondary-100', text: 'text-secondary-800', iconBg: 'bg-secondary-700' },
]

export default function CategoryShortcuts() {
  return (
    <section aria-labelledby="category-shortcut-title" className="mt-10">
      <h2 id="category-shortcut-title" className="sr-only">
        影视分类快捷入口
      </h2>
      <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-4">
        {categories.map((item, index) => {
          const count = movies.filter((movie) => movie.category === item.key).length
          const accent = accents[index % accents.length]
          return (
            <Link
              key={item.key}
              to={`/category?type=${item.key}`}
              className="group flex items-center gap-3 rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-300 hover:bg-background-100"
            >
              <span
                className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-md ${accent.iconBg} text-background-50`}
              >
                <i className={`${item.icon} text-xl`} />
              </span>
              <span className="min-w-0">
                <span className="flex items-center gap-2">
                  <span className="text-sm font-medium text-foreground-950">{item.label}</span>
                  <span className={`rounded px-1.5 py-0.5 text-[10px] ${accent.bg} ${accent.text}`}>
                    {count} 部
                  </span>
                </span>
                <span className="mt-1 block truncate text-[11px] text-foreground-500">
                  {item.desc}
                </span>
              </span>
              <i className="ri-arrow-right-up-line ml-auto shrink-0 text-foreground-400 transition-colors group-hover:text-accent-600" />
            </Link>
          )
        })}

        <Link
          to="/category"
          className="group flex items-center gap-3 rounded-lg border border-dashed border-background-300 bg-background-100 p-4 transition-colors hover:border-accent-400 hover:bg-accent-50"
        >
          <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md bg-primary-950 text-background-50">
            <i className="ri-apps-2-line text-xl" />
          </span>
          <span className="min-w-0">
            <span className="block text-sm font-medium text-foreground-950">全部作品</span>
            <span className="mt-1 block truncate text-[11px] text-foreground-500">
              共 {movies.length} 部示例作品可浏览
            </span>
          </span>
          <i className="ri-arrow-right-up-line ml-auto shrink-0 text-foreground-400 transition-colors group-hover:text-accent-600" />
        </Link>
      </div>
    </section>
  )
}